export default __webpack_public_path__ + "static/comountains-b9de97fec83a21992137af2285b33e1c.jpg";